<template>
  <div class="cover-calculator" ref="calculator">
    <h1>Quick, Simple, Set up in less than 30 seconds</h1>
    <progress-bar :current="step" :total="5"></progress-bar>
    <transition :name="animation" mode="out-in">
      <step-one :base="base" v-if="step === 0" @submit="selectOwnership"></step-one>
      <step-two :base="base" @back="back()" v-else-if="step === 1" @submit="selectFuel"></step-two>
      <step-three :base="base" @back="back()" v-else-if="step === 2" @submit="selectGuarantee"></step-three>
      <step-four :base="base" @back="back()" v-else-if="step === 3" @submit="selectCare" :plans="calculatedPlans"
                 :upcost="upcost" :features="features">
      </step-four>
      <step-five @back="back()" v-else-if="step === 4" :base="base" :plan="selected_plan"
                 :current-first-name="first_name" :current-last-name="last_name" :current-email="email"
                 :current-phone="phone"
                 @submit="setContactDetails">
      </step-five>
      <step-six @back="back()" v-else-if="step === 5" :base="base" :plan="selected_plan" :upcost="upcost"
                :first-name="first_name" :last-name="last_name" :email="email" :phone="phone"
                :fuel="fuel" :guarantee="guarantee" :ownership="ownership" :features="features"></step-six>
    </transition>
    <transition name="fade">
      <div class="benefits" v-if="step <= 2">
        <h3>Our Cover plans...</h3>
        <ul>
          <li>Include all parts and labour</li>
          <li>Have no excess to pay when you need us</li>
          <li>Use employed engineers, not sub-contractors</li>
          <li>Have 24/7 emergency call out</li>
        </ul>
      </div>
    </transition>


  </div>
</template>

<script>
import StepOne from "./components/steps/StepOne";
import StepTwo from "./components/steps/StepTwo";
import StepThree from "./components/steps/StepThree";
import StepFour from "./components/steps/StepFour";
import StepFive from "./components/steps/StepFive";
import StepSix from "./components/steps/StepSix";

import ProgressBar from "./components/ProgressBar";

export default {
  name: "App",
  props: {
    base: {
      type: String,
      required: true,
    },
  },
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    StepSix,
    ProgressBar,
  },
  data() {
    return {
      animation: 'slide-forwards',
      step: 0,
      selected_plan: null,
      guarantee: null,
      fuel: null,
      ownership: null,
      plans: [],
      upcosts: [],
      features: [],
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
    }
  },
  mounted() {
    this.getData();
    window.dataLayer.push({
      event: 'boilerCoverCalculatorInitiate',
      category: 'Boiler Cover Calculator',
      action: 'Cover Calculator Initiate',
      label: 'Boiler Calculator Initiated',
    });
  },
  computed: {
    calculatedPlans() {
      let plans = [];
      if (this.guarantee !== null) {
        for (let i = 0; i < this.plans.length; i++) {
          if (
              (this.guarantee === 0 && this.plans[i].show_in_yes) ||
              (this.guarantee === 1 && this.plans[i].show_in_no) ||
              (this.guarantee === 2 && this.plans[i].show_in_unsure)
          ){
            plans.push(this.plans[i]);
          }
        }
      } else {
        return [];
      }
      return plans;
    },
    upcost() {
      let upcost = 0;
      if (this.ownership === 'homeowner') {
        upcost += parseFloat(this.upcosts.homeowner.value);
      } else if (this.ownership === "landlord") {
        upcost += parseFloat(this.upcosts.landlord.value);
      }
      if (this.fuel === 'gas') {
        upcost += parseFloat(this.upcosts.gas.value);
      } else if (this.fuel === 'lpg') {
        upcost += parseFloat(this.upcosts.lpg.value);
      } else if (this.fuel === 'oil') {
        upcost += parseFloat(this.upcosts.oil.value);
      } else if (this.fuel === 'electric') {
        upcost += parseFloat(this.upcosts.electric.value);
      } else if (this.fuel === 'hybrid') {
        upcost += parseFloat(this.upcosts.hybrid.value);
      } 
      
      return upcost;
    },
  },
  methods: {
    selectGuarantee(option) {
      this.guarantee = option;
      let response = "not-sure";
      if (option === 0) {
        response = 'yes';
      } else if (option === 1) {
        response = 'no';
      }
      window.dataLayer.push({
        event: 'boilerCoverGuaranteeSelect',
        category: 'Boiler Cover Calculator',
        action: 'Select Guarantee',
        label: 'Boiler Cover Guarantee Selected',
        boilerGuarantee: response,
      });
      this.forward();
    },
    selectFuel(option) {
      this.fuel = option;
      window.dataLayer.push({
        event: 'boilerCoverFuelTypeSelect',
        category: 'Boiler Cover Calculator',
        action: 'Select Fuel Type',
        label: 'Boiler Cover Fuel Type Selected',
        fuelType: option,
      });
      this.forward();
    },
    selectOwnership(plan) {
      this.ownership = plan;
      window.dataLayer.push({
        event: 'boilerCoverPropertyOwnershipTypeSelect',
        category: 'Boiler Cover Calculator',
        action: 'Cover Calculator Initiate',
        label: 'Boiler Cover Property Ownership Type Selected',
        ownershipType: plan,
      });
      this.forward();
    },
    selectCare(plan) {
      this.selected_plan = plan;
      window.dataLayer.push({
        event: 'boilerCoverPlanSelect',
        category: 'Boiler Cover Calculator',
        action: 'Select Plan',
        label: 'Boiler Cover Plan Selected',
        boilerPlanType: plan.name,
      });
      this.forward();
    },
    setContactDetails(details) {
      this.first_name = details.first_name;
      this.last_name = details.last_name;
      this.email = details.email;
      this.phone = details.phone;

      this.$axios.post(`${this.base}/calculator/log-customer`, this.$makeForm({
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone: this.phone,
        cover_plan_id: this.selected_plan.id,
      })).catch(e => {
        console.error(e)
      });

      window.dataLayer.push({
        event: 'boilerCoverContactDetails',
        category: 'Boiler Cover Calculator',
        action: 'Contact Details Given',
        label: 'Boiler Cover Plan Contact Details Given',
        boilerPlanType: this.selected_plan.name,
      });

      this.forward();
    },
    back() {
      this.animation = "slide-backward";
      this.$refs['calculator'].scrollIntoView();
      this.step -= 1;
    },
    forward() {
      this.animation = "slide-forward";
      this.$refs['calculator'].scrollIntoView();
      this.step++;
    },
    goTo(step) {
      if (step < this.step) {
        this.animation = "slide-backward";
        this.step = step;
      }
    },
    getData() {
      this.$axios.get(`${this.base}/calculator/init`)
          .then((response) => {
            this.upcosts = response.data.upcosts;
            this.plans = response.data.plans;
            this.features = response.data.features;
          });
    },
    isUnique(plan, plans) {
      for (let i = 0; i < plans.length; i++) {
        if (plans[i].monthly_cost === plan.monthly_cost) {
          return false;
        }
      }
      return true;
    }
  },
}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: sans-serif;
  scroll-behavior: smooth;
}

.cover-calculator {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  font-size: 16px;

  h1 {
    text-align: center;
    font-size: 2rem;
    padding: 2rem 0;
    color: #444444;
    font-weight: normal;

    &::before {
      display: none;
    }
  }

  .steps {
    display: flex;
    justify-content: center;
    list-style: none;
    margin: 2rem 0;

    li {
      margin-right: 1rem;
      font-weight: normal;
      font-size: 0.6rem;
      cursor: pointer;
      transition: 0.2s;

      &.active {
        cursor: default;
        font-weight: bold;
        color: #005EAE;
        transition: 0.2s;
      }

      &.disabled {
        cursor: default;
        color: #444444;
        transition: 0.2s;
      }
    }
  }
}

.step-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 1rem 0;
  box-sizing: border-box;

  .step-header {
    font-size: 1.8rem;
    display: block;
    color: #444444;
    font-weight: normal;
    margin: 1rem 0 0.5rem 0;

    &::before {
      display: none;
    }
  }

  .step-sub-header {
    font-size: 1.5rem;
    display: block;
    color: #444444;
    font-weight: normal;
    margin: 1rem 0 2rem 0;

    &::before {
      display: none;
    }
  }
}

.row {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  &.center {
    justify-content: center;
  }

  &.spaced {
    margin: 1rem 0;
  }
}

.benefits {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 3rem;

  h3, ul {
    margin-left: auto;
    margin-right: auto;
  }

  h3 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    color: #005EAE;
    font-weight: bold;
  }

  ul {
    list-style-type: circle;

    li {
      margin: 1rem 0;
      font-size: 1.5rem;
    }
  }
}

.submit-button {
  background-color: #FF5B18;
  color: #FFFFFF;
  border: 0;
  outline: 0;
  padding: 2rem;
  cursor: pointer;
  font-size: 1.5em;
  border-radius: 5px;
  line-height: 1.5rem;
  font-weight: normal;
  transition: 0.2s;
  margin: 1rem;
  text-align: center;
  min-width: 200px;
  position: relative;
  box-shadow: 0 15px 14px 0 rgba(0, 0, 0, 0.1);


  &:hover {
    &::after {
      height: 100%;
      transition: 0.2s;
    }
  }

  &:after {
    position: absolute;
    border-radius: 5px;
    content: "";
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0;
    z-index: 1;
    background: #ff9700;
    transition: all 0.2s;
  }

  .btn-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    display: block;
    position: relative;
    z-index: 2;
  }

  span {
    margin-top: 0.5rem;
    display: block;
    position: relative;
    z-index: 2;
  }
}

.error {
  color: red;
  font-weight: 300;
}

.logos {
  a, span {
    margin: 0.5rem;

    img {
      height: 40px;
      transition: 0.4s;
    }

    &:hover {
      img {
        transform: scale(1.1);
        transition: 0.4s;
      }
    }
  }
}

.back {
  margin: 2rem 0;
  color: #005EAE;
  font-weight: bold;
  cursor: pointer;
}

.slide-forward-enter-active,
.slide-forward-leave-active,
.slide-backward-enter-active,
.slide-backward-leave-active,
.fade-enter-active,
.fade-leave-active {
  transition: all .5s ease-out;
}

.slide-forward-enter {
  transform: translate(100%, 0);
}

.slide-forward-leave-to {
  transform: translate(-100%, 0);
}

.slide-backward-enter {
  transform: translate(-100%, 0);
}

.slide-backward-leave-to {
  transform: translate(100%, 0);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}


@media only screen and (max-width: 860px) {
  .step-container {
    .step-header {
      font-size: 1.4rem;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue